const Functions = []

const uniqueItemsReducer = (acc, item) => {
    // Verifica si el item ya está en el acumulador basado en productId
    if (!acc.some(existingItem => existingItem.productId === item.productId)) {
        acc.push(item);
    }
    return acc;
};

// Función para filtrar duplicados en un array de items
const removeDuplicates = (itemsArray) => {
    return itemsArray.reduce(uniqueItemsReducer, []);
};


export { removeDuplicates }



